import styled from 'styled-components';
import { TabPanels as TabPanelsComponent, ListItem, ListItemColumn } from '@pearsontechnology/aero-components';

export const ActionsRightWrapper = styled.div`
  display: flex;
`;

export const ProjectActionsWrapper = styled.div`
  margin-right: 27px;
`;

export const TabPanels = styled(TabPanelsComponent)`
  padding-top: 20px;
`;

export const PlaceholderListItem = styled(ListItem)`
  height: 66px;
  background: ${(props) => (props.theme.themeId === 'dark') ? '' : 'rgba(216, 216, 216, 0.1)'};

`;

export const PlaceholderText = styled.div`
  border-radius: 4px;
  border: 2px dashed ${(props) => props.theme['color.border']};
  text-align:center;
  width:100%;
  padding: 20px 0;
  font-style: italic;
`;

export const PlaceholderListItemColumn = styled(ListItemColumn)`
  padding: 3px;
  & :first-child {
    padding-left: 3px;
  }
  &:last-child{
    padding-right: 3px;
  }
`;
